import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder } from 'Components/utils';
import {
  PROGRESS_PIE_SIZE_AS_SPACING_MULTIPLIER,
} from 'Views/Page/Content/Templates/planSummaryPageTemplate/subtleProgressPie';

const useStyles = buildUseStyles('BottomUpConnector', (theme) => ({
  root: {
    ...getBorder(theme, {
      left: true,
      borderStyle: 'dashed',
      color: theme.palette.grey[400],
    }),

    position: 'absolute',
    bottom: '0', // Start at the top of the step indicator, where this should be placed
    // Dividing the size of the progress pie by 2 gives you the middle of the pie.
    // However, we're adding a 1px border, so it would be on the right of the middle - not dead on!
    // This sounds fine except that this line touches the line on the progress pie, which starts *exactly* in the middle.
    // Having this off just a little bit becomes noticible because that one is so spot on, so make this one spot on by adjusting it by 0.5px to be right in the middle
    left: theme.spacing(PROGRESS_PIE_SIZE_AS_SPACING_MULTIPLIER / 2) - 0.5,

    // Render this thing going up very far, and let an overflow:hidden around the entire stepper stop it from going too far, with another endcap to stop it from being visible above the first step indicator
    // As long as we don't have 100,000px in this stepper we're good :)
    height: '99999px',
  },
}));

// Renders a connector between steps.
// Use this on the very last step and you'll get a nice line going straight up forever.
// Use overflow:hidden on the parent stepper so that it doesn't go beyond the stepper.
// However, it will still go above the first step's indicator - use StopConnectorAtTheTop to cover it up with the background color so it's invisible.
// Additionally, it will go on top of every step indicator - wrap indicators in OnTopOfConnector to get around that
export function BottomUpConnector() {
  const classes = useStyles();
  return (
    <div className={classes.root} />
  );
}
